// @flow
import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { DIALOG_TYPE as DIALOG_ACCOUNTS_DISCOVERY, mkAccountDiscoveryDialogProps }
  from 'components/Dialogs/AccountDiscovery/types';
import { refreshAccounts } from 'data/accounts/actions';
import { createDialog } from 'data/rootUi/actions';
import { mkRootUiData } from 'data/rootUi/types';

import type { InstitutionLogin } from './types';

export const getInstitutionLogins = createAction('GET_INSTITUTION_LOGINS');
export const getInstitutionLoginsSuccess = createAction('GET_INSTITUTION_LOGINS_SUCCESS');
export const getInstitutionLoginsFailure = createAction('GET_INSTITUTION_LOGINS_FAILURE');

export const updateInstitutionLogin = createAction('UPDATE_INSTITUTION_LOGIN');
export const updateInstitutionLoginSuccess = createAction('UPDATE_INSTITUTION_LOGIN_SUCCESS');
export const updateInstitutionLoginFailure = createAction('UPDATE_INSTITUTION_LOGIN_FAILURE');

export const deleteInstitutionLogin = createAction('DELETE_INSTITUTION_LOGIN');
export const deleteInstitutionLoginSuccess = createAction('DELETE_INSTITUTION_LOGIN_SUCCESS');
export const deleteInstitutionLoginFailure = createAction('DELETE_INSTITUTION_LOGIN_FAILURE');

export const addInstitutionLoginAndAccounts = createAction('ADD_INSTITUTION_LOGIN_AND_ACCOUNTS');
export const addInstitutionLoginAndAccountsResponse = createAction('ADD_INSTITUTION_LOGIN_AND_ACCOUNTS_RESPONSE');

export const refreshAccountsTriggeredCredentialsRequest = createAction('REFRESH_ACCOUNTS_TRIGGERED_CREDENTIALS_REQUEST');

export const refreshAccountsCredentialsProvided = createAction('REFRESH_ACCOUNTS_CREDENTIALS_PROVIDED');
export const refreshAccountsCredentialsNotProvided = createAction('REFRESH_ACCOUNTS_CREDENTIALS_NOT_PROVIDED');

export const institutionLoginSetCredentialsBlob = createAction('INSTITUTION_LOGIN_SET_CREDENTIALS_BLOB');

export const doReAuthenticate = createAction(
  createDialog,
  (institutionLogin) => mkRootUiData({
    type: DIALOG_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: ImmutableMap(mkAccountDiscoveryDialogProps({
      mode: 'RE-AUTHENTICATE',
      institutionLogin,

      afterCloseAction: refreshAccounts({ institutionLoginId: institutionLogin.id }),
    })),
  })
);

export const doUpdateCredentials = createAction(
  createDialog,
  (institutionLogin) => mkRootUiData({
    type: DIALOG_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: ImmutableMap(mkAccountDiscoveryDialogProps({
      mode: 'UPDATE-CREDENTIALS',
      institutionLogin,

      afterCloseAction: refreshAccounts({ institutionLoginId: institutionLogin.id }),
    })),
  })
);

export const doUpdateFi = createAction(
  createDialog,
  (institutionLogin: InstitutionLogin) => mkRootUiData({
    type: DIALOG_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: ImmutableMap(mkAccountDiscoveryDialogProps({
      mode: 'UPDATE-FI',
      institutionLogin: institutionLogin.set('institutionId', null),

      // afterCloseAction: refreshAccounts({ institutionLoginId: institutionLogin.id }),
    })),
  })
);


